import { render, staticRenderFns } from "./input-textarea.vue?vue&type=template&id=fef56d9e&scoped=true&"
import script from "./input-textarea.vue?vue&type=script&lang=js&"
export * from "./input-textarea.vue?vue&type=script&lang=js&"
import style0 from "./input-textarea.vue?vue&type=style&index=0&id=fef56d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef56d9e",
  null
  
)

export default component.exports